import none from '../../img/kandokLogo.jpg'
export const iceCream =[
 {
  "id": 101,
  "title": "میوه ای",
  "price": 50,
  "image": none
 },
 {
  "id": 102,
  "title": "شکلاتی",
  "price": 50,
  "image": none
 },
 {
  "id": 103,
  "title": "وانیلی",
  "price": 50,
  "image": none
 },
 {
  "id": 104,
  "title": "سنتی",
  "price": 60,
  "image": none
 }
]